export default "::selection {\n  background-color: var(--selection-color);\n}";